//CSS Import
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppProperties, getDateFormat } from '../../../../common/functions';
import {
    Button,
    Grid,
    Snackbar,
    Typography,
    Box,
    Paper,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { isMobile } from 'react-device-detect';
import SFGoalDialog from './SFGoalDialog';
import SFGoalSlider from './SFGoalSlider';
import { BeatLoader } from 'react-spinners';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import moment from 'moment';
import { AppContext } from '../../../../AppContext';
import confetti from '../../../../images/png/confetti.png';
import MathJaxPreview from '../../../../components/react-mathjax-preview';

class SFSplashScreenOld extends Component {
    static contextType = AppContext;
    appProperties = AppProperties();

    constructor(props) {
        super(props);
        this.QuizList = this.QuizList.bind(this);
        this.instructionsRef = React.createRef();
        this.state = {
            showGoal: false,
            showSnackBar: false,
            snackBarMessage: '',
            categoriesData: [],
            loading: false,
        };
    }

    componentDidMount() {
        this.applyInstructionImageAccessibility();
        if (this.props.quizID) {
            this.setState({
                loading: true
            })
            // get all the categories by quiz id with course
            this.props.apiService({
                method: 'post',
                url: '/getCategoriesByQuizID',
                data: {
                    quizID: this.props.quizID,
                    parentQuizID: this.props.parentQuizID,
                    practiceCount: this.props.practiceCount,
                }
            }).then(res => {
                if (res && res.data && res.data) {

                    this.setState({
                        categoriesData: res.data.category_names
                    })
                }
            }).catch(err => console.log("errr", err))
                .finally(() => {
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    componentDidUpdate() {
        this.applyInstructionImageAccessibility();
    }

    applyInstructionImageAccessibility = () => {
        if (!this.instructionsRef.current) return;

        this.instructionsRef.current.querySelectorAll('img').forEach((image) => {
            if (image.getAttribute('aria-hidden') === 'true') return;

            const title = (image.getAttribute('title') || '').trim();
            const alt = (image.getAttribute('alt') || '').trim();
            const description = [
                title && `Title: ${title}`,
                alt && `Alternative text: ${alt}`,
            ].filter(Boolean).join('. ');

            if (description) image.setAttribute('aria-label', description);
        });
    };

    QuizList() {
        this.props.history.push('/');
    }

    handleGoalChangeForQuiz = (type, newGoal) => {
        const updatedCategoriesData = this.state.categoriesData.map((cat) =>
            type === 'accuracy'
                ? { ...cat, accuracyGoal: newGoal }
                : { ...cat, timeGoal: newGoal }
        );
        const payload = {
            quizID: this.props.quizID,
            practiceCount: this.props.practiceCount,
            isAccuracy: type === 'accuracy',
            isTime: type === 'time',
            categoryGoals: this.state.categoriesData.map((cat) => ({
                catKey: `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`,
                quizID: this.props.quizID,
                isAccuracy: true,
                accuracyGoal: type === 'accuracy' ? newGoal : 0,
                timeGoal: type === 'time' ? newGoal : 0,
            })),
        };
        this.setGoal(payload);
        this.setState({ categoriesData: updatedCategoriesData });
    };

    handleSaveGoalForCategories = (updatedCategoriesData) => {
        this.setState({ categoriesData: updatedCategoriesData });
    };

    closeGoalDialog = () => this.setState({ showGoal: false });

    closeSnackBar = (event, reason) => {
        if (reason === 'clickaway') return;
        this.setState({ showSnackBar: false, snackBarMessage: '' });
    };

    stripPTagsAndCheckEmpty = (html) => {
        const strippedHtml = (html || '').replace(/(<([^>]+)>)/gi, '').trim();
        return strippedHtml === '';
    };

    // ---------- STYLE HELPERS ----------
    containerSx = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        px: 2,
    };
    cardWrapperSx = {
        maxWidth: 1100,
        width: '100%',
        mx: 'auto',
        p: { xs: 3, sm: 5 },
        borderRadius: 3,
        border: '1px solid #e5e7eb',
        boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
        backgroundColor: '#fff',
    };
    labelSx = {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: '#6b7280',
    };
    valueSx = {
        mt: 0.5,
        fontSize: 20,
        fontWeight: 600,
        color: '#333',
    };

    render() {
        // ---------- LOADING ----------
        if (this.state.loading) {
            return (
                <Box sx={this.containerSx}>
                    <Paper sx={this.cardWrapperSx} elevation={0}>
                        <Box role="status" aria-live="polite" display="flex" flexDirection="column" alignItems="center" py={6} gap={2}>
                            <BeatLoader aria-hidden="true" color="#bb0000" />
                            <Typography>Loading assignment details</Typography>
                        </Box>
                    </Paper>
                </Box>
            );
        }

        // ---------- CLOSED / EXPIRED / COMPLETED / INVALID ----------
        let text =
            this.props.isTest === 1
                ? this.props.testWindowEnded
                    ? 'Sorry! The Test is Closed!'
                    : this.props.isTimerExpired == 1
                        ? 'Sorry! The Test Timer has Expired!'
                        : this.props.hasCompleted == 1
                            ? 'Congratulations! You have completed the test.'
                            : ''
                : this.props.quizWindowEnded
                    ? 'Sorry! The Quiz is Closed!'
                    : this.props.hasCompleted == 1
                        ? 'Congratulations! You have completed the quiz.'
                        : '';

        if (this.props.invalidQuiz) text = 'Please start this assignment in Carmen';
        if (this.props.quizNotPublished)
            text = 'This quiz is not yet published. Please ask your instructor to publish.';

        if (text !== '') {
            const isSuccess = this.props.hasCompleted == 1;

            if (isSuccess) {
                return (
                    <Box sx={this.containerSx}>
                        <Paper sx={this.cardWrapperSx} elevation={0}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    py: 4,
                                }}
                            >
                                <img src={confetti} alt="" aria-hidden="true" style={{ maxWidth: 120, marginBottom: 16 }} />

                                <Typography
                                    component="h1"
                                    align="center"
                                    color="primary"
                                    sx={{ fontSize: 32, fontWeight: 700, mb: 1 }}
                                >
                                    YOU DID IT!
                                </Typography>

                                <Typography
                                    component="p"
                                    align="center"
                                    sx={{ fontSize: 20, fontWeight: 500, mt: 2 }}
                                >
                                    Congratulations!{' '}
                                    {this.appProperties.currentUserData.isAnonymous
                                        ? ''
                                        : `${this.props.globalProperties.currentUserData.GivenName} `}
                                    You have completed the {this.props.isTest === 1 ? 'test' : 'assignment'} - {this.props.title}
                                </Typography>

                                <Typography
                                    component="p"
                                    align="center"
                                    sx={{ fontSize: 20, fontWeight: 500, mt: 0 }}
                                >
                                    You are now a Student Ninja!
                                </Typography>

                                {this.props.ltiUserID ? null : (
                                    <Button
                                        variant="contained"
                                        onClick={this.QuizList}
                                        sx={{ mt: 4, textTransform: 'none', px: 3, borderRadius: 1.5, '&.Mui-focusVisible': { outline: '3px solid #1d1d1d', outlineOffset: '3px' } }}
                                    >
                                        Home
                                    </Button>
                                )}
                            </Box>
                        </Paper>
                    </Box>
                );
            }

            return (
                <Box sx={this.containerSx}>
                    <Paper sx={this.cardWrapperSx} elevation={0}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                py: 4,
                            }}
                        >

                            <Typography
                                component="h1"
                                align="center"
                                sx={{ fontSize: 24, fontWeight: 700, color: '#333', mb: 1 }}
                            >
                                {text}
                            </Typography>

                            <Typography
                                component="p"
                                align="center"
                                sx={{ fontSize: 14, color: '#6b7280', mb: 4, maxWidth: 400 }}
                            >
                                {this.props.invalidQuiz
                                    ? 'This assignment must be accessed through Carmen.'
                                    : this.props.quizNotPublished
                                        ? 'Please reach out to your instructor for further assistance.'
                                        : 'If you believe this is an error, please contact your instructor.'}
                            </Typography>

                            <Box display="flex" justifyContent="center" gap={2}>
                                {this.props.invalidQuiz && this.props.carmenAssignmentLink ? (
                                    <Button
                                        variant="contained"
                                        href={this.props.carmenAssignmentLink}
                                        sx={{ textTransform: 'none', px: 3, borderRadius: 1.5, '&.Mui-focusVisible': { outline: '3px solid #1d1d1d', outlineOffset: '3px' } }}
                                    >
                                        Take me to Carmen
                                    </Button>
                                ) : null}
                                {this.props.ltiUserID ? null : (
                                    <Button
                                        variant="outlined"
                                        onClick={this.QuizList}
                                        sx={{ textTransform: 'none', px: 3, borderRadius: 1.5, '&.Mui-focusVisible': { outline: '3px solid #1d1d1d', outlineOffset: '3px' } }}
                                    >
                                        Home
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Paper>
                </Box>
            );
        }

        // ---------- PRACTICE DISABLED ----------
        if (!this.props.allowPractice) {
            return (
                <Box sx={this.containerSx}>
                    <Paper sx={this.cardWrapperSx} elevation={0}>
                        <Typography component="h1" align="center" sx={{ fontSize: 18, color: '#e65100', py: 4 }}>
                            {this.props.ltiPracticeMessage
                                ? this.props.ltiPracticeMessage
                                : 'Sorry, this quiz is currently unavailable for practice. Please request the instructor to enable practice mode for this quiz.'}
                        </Typography>
                    </Paper>
                </Box>
            );
        }

        // ---------- MAIN SPLASH ----------
        const showDates =
            !(this.context.isSpecialCourse || this.appProperties.isLTIStudent || this.props.courseName === 'null' || this.props.isTutorial);

        return (
            <Box component="section" aria-labelledby="assignment-splash-title" sx={this.containerSx}>
                {/* Conditional Goal Dialog — preserved */}
                {this.state.showGoal ? (
                    <SFGoalDialog
                        open={this.state.showGoal}
                        onClose={this.closeGoalDialog}
                        categoriesData={this.state.categoriesData}
                        handleGoalChangeForQuiz={this.handleGoalChangeForQuiz}
                        handleSaveGoalForCategories={this.handleSaveGoalForCategories}
                        {...this.props}
                    />
                ) : null}

                <Paper sx={this.cardWrapperSx} elevation={0}>
                    {/* Heading */}
                    <Typography
                        id="assignment-splash-title"
                        component="h2"
                        align="center"
                        sx={{
                            fontSize: { xs: 26, sm: 32 },
                            fontWeight: 700,
                            color: '#333',
                            mb: 5,
                        }}
                    >
                        WELCOME{' '}
                        {this.appProperties.currentUserData.isAnonymous
                            ? ''
                            : `${this.props.globalProperties.currentUserData.GivenName}!`}
                    </Typography>

                    {/* Two-column horizontal layout */}
                    <Grid container spacing={4}>
                        {/* LEFT COLUMN — assignment details */}
                        <Grid item xs={12} md={6}>
                            <Box sx={{ mb: 3 }}>
                                <Typography component="h3" sx={this.labelSx}>{this.props.isTutorial ? "Tutorial" : "Assignment"} Name</Typography>
                                <Typography component="p" sx={this.valueSx}>{this.props.title}</Typography>
                            </Box>

                            {this.props.isTutorial ? null : 
                                <Box sx={{ mb: 3 }}>
                                    <Typography component="h3" sx={this.labelSx}>Assignment Type</Typography>
                                    <Typography component="p" sx={this.valueSx}>
                                        {this.props.isTest === 0 ? 'Mastery' : 'Test'}
                                        {this.props.practiceCount > 0 ? ' (Practice)' : ''}
                                    </Typography>
                                </Box>
                            }

                            {showDates ? (
                                <Grid container spacing={2} sx={{ mb: 3 }}>
                                    <Grid item xs={6}>
                                        <Typography component="h3" sx={this.labelSx}>Open</Typography>
                                        <Typography component="p" sx={{ ...this.valueSx, fontSize: 18 }}>
                                            {getDateFormat(this.props.startDate, this.props.timeZone)}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography component="h3" sx={this.labelSx}>Close</Typography>
                                        <Typography component="p" sx={{ ...this.valueSx, fontSize: 18 }}>
                                            {getDateFormat(this.props.dueDate, this.props.timeZone)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            ) : null}

                            {!this.stripPTagsAndCheckEmpty(this.props.splashText) ? (
                                <Box
                                    component="section"
                                    aria-labelledby="instructor-instructions-title"
                                    sx={{
                                        backgroundColor: '#e3f2fd',
                                        border: '1px solid #bbdefb',
                                        borderLeft: '4px solid #1976d2',
                                        borderRadius: 2,
                                        px: 2,
                                        py: 1,
                                    }}
                                >
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <InfoOutlinedIcon aria-hidden="true" sx={{ color: '#1976d2' }} />
                                        <Typography id="instructor-instructions-title" sx={{ fontWeight: 600, color: '#0d47a1 !important', fontSize: 15 }}>
                                            Instructions from your Instructor:
                                        </Typography>
                                    </Box>
                                    <Box ref={this.instructionsRef} sx={{ maxHeight: 100, overflowY: 'auto', padding:'5px 0px' }}>
                                        {/* <Box
                                            sx={{ fontStyle: 'italic', color: '#0d47a1' }}
                                            dangerouslySetInnerHTML={{ __html: this.props.splashText }}
                                        /> */}
                                        <MathJaxPreview math={this.props.splashText} />
                                    </Box>
                                </Box>
                            ) : null}
                        </Grid>

                        {/* RIGHT COLUMN — categories list */}
                        <Grid item xs={12} md={6}>
                            <Box
                                component="section"
                                aria-labelledby="assignment-categories-title"
                                sx={{
                                    backgroundColor: '#f9fafb',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: 2,
                                    p: 3,
                                    height: '100%',
                                }}
                            >
                                <Typography id="assignment-categories-title" component="h2" sx={{ ...this.labelSx, mb: 2 }}>Categories in {this.props.isTutorial ? "Tutorial" : "Assignment"} ({this.state.categoriesData?.length || 0})</Typography>
                                <Box component="ul" sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxHeight: 300, overflowY: 'auto', padding:"0 4px", listStyle: 'none', margin: 0 }}>
                                    {this.state.categoriesData?.map((cat, index) => (
                                        <Box
                                            component="li"
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                px: 2,
                                                py: 1,
                                                backgroundColor: '#fff',
                                                borderRadius: 1.5,
                                                border: '1px solid #e5e7eb',
                                            }}
                                        >
                                            <Box
                                                aria-hidden="true"
                                                sx={{
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#a7b1b7',
                                                    flexShrink: 0,
                                                }}
                                            />
                                            <Typography sx={{ fontSize: 15, color: '#111827', fontWeight: 500 }}>
                                                {cat.category_label ? cat.category_label : cat.category_name}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* CTA / Empty categories message */}
                    <Box display="flex" justifyContent="center" mt={5}>
                        {this.state.categoriesData === null ||
                        this.state.categoriesData === undefined ||
                        this.state.categoriesData?.length === 0 ? (
                            <Typography sx={{ color: '#e65100', fontWeight: 500 }}>
                                No categories present in the quiz. Please contact your instructor
                            </Typography>
                        ) : (
                            <Button
                                variant="contained"
                                disabled={this.props.isLockedOut || this.props.tutorialReadOnly}
                                onClick={() => this.props.onShowCategorySelection()}
                                aria-label={`Start ${this.props.isTutorial ? "tutorial" : "assignment"}: ${this.props.title}`}
                                sx={{
                                    px: 4,
                                    py: 1.3,
                                    fontWeight: 600,
                                    textTransform: 'none',
                                    borderRadius: 1.5,
                                    '&.Mui-focusVisible': { outline: '3px solid #1d1d1d', outlineOffset: '3px' },
                                }}
                            >
                                {this.props.isLockedOut ? 'Locked' : `Start ${this.props.isTutorial ? "Tutorial" : "Assignment"}`}
                            </Button>
                        )}
                    </Box>

                    {this.props.tutorialReadOnly ? (
                        <Typography
                            align="center"
                            sx={{ mt: 1, fontSize: 13, color: '#6b7280', fontStyle: 'italic' }}
                        >
                            You are previewing this tutorial. Start is disabled in preview mode.
                        </Typography>
                    ) : null}

                    {/* Locked-out note */}
                    {this.props.isLockedOut ? (
                        <Typography
                            align="center"
                            sx={{ mt: 3, color: '#e65100', fontStyle: 'italic' }}
                        >
                            <strong>Note:</strong> You've attempted too many times. Your assignment is now locked! Please contact your teacher.
                        </Typography>
                    ) : null}

                    {/* Snackbar */}
                    <Snackbar
                        open={this.state.showSnackBar}
                        message={this.state.snackBarMessage}
                        onClose={this.closeSnackBar}
                        autoHideDuration={4000}
                    />
                </Paper>
            </Box>
        );
    }
}

SFSplashScreenOld.propTypes = {
    title: PropTypes.string.isRequired,
    splashText: PropTypes.string,
};

export default SFSplashScreenOld;
